module.exports = __webpack_public_path__ + "static/media/A34.2137e50a.png";